import { useEffect, useState } from 'react'
import { isValidJSON } from 'Services/WeaverUtils'
import AceInput from './AceInput'
import 'ace-builds/webpack-resolver'
import 'ace-builds/src-noconflict/mode-html'
import "ace-builds/src-noconflict/mode-json5";
import 'ace-builds/src-noconflict/snippets/html'
import MapInput from '../MapInput'

SparqlWithVars = ({ value, onChange, ...props }) ->

  cleanValue = (v) ->
    if v is undefined
      ''
    else if typeof v is 'object'
      JSON.stringify(v, null, 2)
    else if isValidJSON(v)
      JSON.stringify(JSON.parse(v), null, 2)
    else
      v

  [workValue, setWorkValue] = useState(cleanValue(value))
  [varsMap, setVarsMap] = useState({})

  useEffect( ->
    try
      setVarsMap(Weaver.Attribute.withVarsMap(workValue))
    undefined
  , [workValue])

  updateMap = (_varsMap) ->
    setVarsMap(_varsMap)
    try
      _workValue = Weaver.Attribute.updateWithVars(workValue, _varsMap)
    setWorkValue(_workValue)

  localChange = (v) ->
    setWorkValue(v)
    onChange(v)

  <>
    <AceInput
      localChange={localChange}
      workValue={workValue}
      {...props}
    />
    { if (Object.keys(varsMap).length > 0) then <MapInput initialValue={varsMap} onChange={updateMap} /> else null }
  </>

export default SparqlWithVars
